/** Server-side bulk VCN job lifecycle (shared across users / sessions). */
export enum VcnBulkJobState {
  QUEUED = 'queued',
  RUNNING = 'running',
  TIMEOUT = 'timeout',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export interface VcnBulkJobStatus {
  jobId: string
  state: VcnBulkJobState
  /** Total items accepted for processing. */
  totalCount: number
  /** Items finished successfully so far. */
  completedCount: number
  /** Subset of completed that were terminate-only. */
  terminateCompleted: number
  /** Subset of completed that were terminate + new card. */
  terminateAndNewCompleted: number
  /** Subset of completed that were create-new (no termination). */
  createNewCompleted: number
  failedCount: number
  message?: string
}
